import moment from "moment";
import t from "../CommonComponents/localization";
import { AddressAction } from "../../actions/Address";
import { userService } from "../../services/user.service";

export const formatPosition = (value, key) => {
  if (value != null && typeof value === "object") {
    value = value[key];
  }
  switch (key) {
    case "fixTime":
    case "deviceTime":
    case "serverTime":
    case "eventTime":
      return moment(value).format("DD-MM-YYYY hh:mm A");
    case "latitude":
    case "longitude":
      return value.toFixed(5);
    case "speed":
    case "course":
      return value.toFixed(1);
    case "batteryLevel":
      return value + "%";
    default:
      if (typeof value === "number") {
        return formatNumber(value);
      } else if (typeof value === "boolean") {
        return formatBoolean(value);
      } else {
        return value;
      }
  }
};

export const formatBoolean = (value) => {
  return value ? t("sharedYes") : t("sharedNo");
};

export const formatNumber = (value, precision = 1) => {
  return Number(value.toFixed(precision));
};

export const formatDate = (value, format = "DD-MM-YYYY hh:mm:ss A") => {
  return moment(value).format(format);
};
export const utcToLocalDate = (value) => {
  let UtcDate = value + " UTC";
  var date = new Date(UtcDate);

  return formatDate(date.toString());
};

export const formatDistance = (value, unit) => {
  switch (unit) {
    case "mi":
      return `${(value * 0.000621371).toFixed(2)} ${t("sharedMi")}`;
    case "nmi":
      return `${(value * 0.000539957).toFixed(2)} ${t("sharedNmi")}`;
    case "km":
    default:
      return `${(value * 0.001).toFixed(2)} ${t("sharedKm")}`;
  }
};

export const formatSpeed = (value, unit) => {
  switch (unit) {
    case "kmh":
      return `${(value * 1.852).toFixed(2)} Km/Hr`;
    case "mph":
      return `${(value * 1.15078).toFixed(2)} ${t("sharedMph")}`;
    case "kn":
    default:
      return `${(value * 1).toFixed(2)} ${t("sharedKn")}`;
  }
};

export const formatVolume = (value, unit) => {
  switch (unit) {
    case "impGal":
      return `${(value / 4.546).toFixed(2)} ${t("sharedGallonAbbreviation")}`;
    case "usGal":
      return `${(value / 3.785).toFixed(2)} ${t("sharedGallonAbbreviation")}`;
    case "ltr":
    default:
      return `${(value / 1).toFixed(2)} ${t("sharedLiterAbbreviation")}`;
  }
};

export const formatHours = (value) => {
  let hour = moment.duration(value).hours();
  let minute = moment.duration(value).minutes();
  return `${hour} Hr ${minute} Min`;
};

export function convertSecondsToHM(seconds) {
  const totalMinutes = Math.floor(seconds / 60); // convert seconds → minutes
  const hours = Math.floor(totalMinutes / 60); // get hours
  const minutes = totalMinutes % 60; // remaining minutes
  return `${hours} Hr ${minutes} Min`;
}
export const formatCoordinate = (key, value, unit) => {
  var hemisphere, degrees, minutes, seconds;
  if (key === "latitude") {
    hemisphere = value >= 0 ? "N" : "S";
  } else {
    hemisphere = value >= 0 ? "E" : "W";
  }

  switch (unit) {
    case "ddm":
      value = Math.abs(value);
      degrees = Math.floor(value);
      minutes = (value - degrees) * 60;
      return degrees + "° " + minutes.toFixed(6) + "' " + hemisphere;
    case "dms":
      value = Math.abs(value);
      degrees = Math.floor(value);
      minutes = Math.floor((value - degrees) * 60);
      seconds = Math.round((value - degrees - minutes / 60) * 3600);
      return degrees + "° " + minutes + "' " + seconds + '" ' + hemisphere;
    default:
      return value.toFixed(6) + "°";
  }
};

export const formatAddress = async (lat, lng, index) => {
  try {
    let apiEndpoint = `${
      JSON.parse(sessionStorage.getItem("data")).addressUrl
    }`;
    // let apiEndpoint =  `http://eclvts.com/watsoo-locationconverter/address/v1/fetch_address`

    let payload = {
      appKey: parseInt(
        JSON.parse(sessionStorage.getItem("data")).addressAppKey
      ),
      coordinatesDTOList: [
        {
          latitude: lat,
          longitude: lng,
        },
      ],
    };
    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200 && 201) {
      return "addressss";
    } else {
      return "";
    }
  } catch (error) {
    console.log("error", error);
    return "";
  }
};
